import { ActionID, PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';
import {
    IOpenControlCenterPostLoginOptions,
    IPostLoginActionsState,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { v4 as uuidv4 } from 'uuid';
import { UkMigrationElasticEvents } from '../../uk-migration/enums';
import { IActionHandlerFactory } from '../../action-handler/models/IActionHandlerFactory';
import { LoaderManager } from '../../../loaders/LoaderManager';

const ModuleName = 'OpenControlCenterPostLoginAction';

export class OpenControlCenterPostLoginAction extends PostLoginActionBase {
    private get _actionHandlerFactoryPromise(): Promise<IActionHandlerFactory> {
        return LoaderManager.Instance.ActionHandlerFactoryLoader.Instance;
    }

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.OpenControlCenterFull, ModuleName, state);
    }

    protected override canExecute = (
        options?: IOpenControlCenterPostLoginOptions,
    ): Promise<boolean> => {
        const openControlCenterFullRequired = options?.enabled || false;
        return Promise.resolve(openControlCenterFullRequired);
    };

    protected override doAction = async (
        options: IOpenControlCenterPostLoginOptions,
    ): Promise<boolean> => {
        const envelop = { headers: { publisher: ModuleName }, topic: null };
        const trackingEvent = {
            dataString: JSON.stringify({}),
            event: UkMigrationElasticEvents.OpenControlCenterPostLoginAction,
        };
        this._clientTracking.onSendEvent(trackingEvent, envelop);
        this.clearOptions();
        const { launchInfo } = options;

        const actionHandlerFactory = await this._actionHandlerFactoryPromise;
        await actionHandlerFactory.performAction({
            actionID: ActionID.openControlCenterFull,
            correlationID: uuidv4(),
            launchInfo,
            actionData: {},
        });
        this.completeAction();
        return false;
    };
}
